import React from 'react';
import background from '../../assets/pollution.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoPollution extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        description="Pollution"
        paragraph="Chemical runoff, microplastics, debris and oil spills are persistent byproducts of human activity which ultimately threaten human health, wildlife, and society at large."
        background={background}
     />
  
  );
 }
}   

export default InfoPollution;